import { StudentLessonToday } from "@godalming/api-types";
import { Card, Group, Table, Text } from "@mantine/core"
import { useCourseNavigation, useCourseNavigationEnabled } from "@features/course-overview/useCourseNavigation";
import { RegMarkBadge } from "@ui/RegMarkBadge";
import { formatClockTime } from "@utils/formatClockTime";

export const LessonsToday: React.FC<{ lessons: StudentLessonToday[] | null }> = ({ lessons }) => {

    const openCourse = useCourseNavigation()
    const courseNavigationEnabled = useCourseNavigationEnabled()

    if (!lessons || lessons.length === 0) {
        return (
            <Card withBorder className={'h-fit!'}>
                <Card.Section px={6} py={3} inheritPadding>
                    <Group gap={5}>
                        <div className={'size-2 rounded-full'} style={{ backgroundColor: 'light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-3))' }} />
                        <Text size="xs" c={'dimmed'}>Lessons today</Text>
                    </Group>
                </Card.Section>
                <Card.Section p={'xs'} pt={0}>
                    <Text size="xs" fw={500} c="dimmed">No lessons today</Text>
                </Card.Section>
            </Card>
        )
    }

    return (
        <Card 
            withBorder 
            className={'shadow-none! h-fit!'} 
        >
            <Card.Section px={'xs'} py={3} inheritPadding>
                <Group gap={5}>
                    <Text size="xs" c={'dimmed'}>Lessons today</Text>
                </Group>
            </Card.Section>
            <Card.Section pt={0} pb={7}>
                <Table 
                    highlightOnHover 
                    horizontalSpacing="xs" 
                    verticalSpacing={0}
                    withRowBorders={false}
                >
                    <Table.Tbody>
                        {lessons.map((lesson) => (
                            <Table.Tr
                                key={`${lesson.idClass}-${lesson.period}-${lesson.startTime}`}
                                className={courseNavigationEnabled ? 'cursor-pointer' : undefined}
                                onClick={courseNavigationEnabled ? (event) => {
                                    event.preventDefault()
                                    event.stopPropagation()
                                    openCourse({ type: "class", id: lesson.idClass.toString() })
                                } : undefined}
                            >
                                <Table.Td>
                                    <Text fw={500} size="xs">{formatClockTime(lesson.startTime)}</Text>
                                </Table.Td>
                                <Table.Td style={{ maxWidth: 120 }}>
                                    <Text size="xs" lineClamp={1}>{lesson.subjectName}</Text>
                                </Table.Td>
                                {/* <Table.Td>
                                    <Text size="xs" lineClamp={1}>{lesson.courseCode};{lesson.classCode}</Text>
                                </Table.Td> */}
                                {/* <Table.Td>
                                    <Text size="xs" lineClamp={1}>{lesson.teacherInitials}</Text>
                                </Table.Td> */}
                                <Table.Td>
                                    <RegMarkBadge regMark={lesson.regMark} fullLabel badgeProps={{ size: 'sm' }} />
                                </Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            </Card.Section>
        </Card>
    )
}
